// 创建文件en/index.js
const Korean = {
    my: "나의",
    today: "오늘",
    this_week: "이번 주",
    this_month: "이번 달",
    last_month: "지난 달",
    this_year: "올해",
    number_of_people: "인원 수",
    amount: "금액",
    enter_username_id_to_search: "사용자 이름 ID를 입력하여 검색",
    team_list: "팀 목록",
    registration_time: "등록 시간",
    selling_face_value: "판매 금액",
    click_for_details: "자세히 보기",
    "agent_login": "에이전트 로그인",
    "Agent.Center": "에이전트 센터",
    'SignOut': '계정 로그아웃',
    'Contact us': "문의하기",
    'Download our app': "우리 앱 다운로드",
    'Download it from': "다운로드 URL",
    'About Us': "회사 소개",
    'Gobuy USA was founded in 2012': "Gobuy USA는 2021년에 설립되었습니다.",
    'Customer service': "고객 서비스",
    'frequently asked question': "FAQ",
    'Return and exchange policy': "반품 및 교환 정책",
    'Shipping and distribution': "유통 및 배송",
    'Contact us by email': "이메일로 문의하기",
    'Privacy Policy and Terms of Use': "개인 정보 보호 정책 및 이용 약관",
    'Privacy Policy': "개인 정보 보호 정책",
    'Terms of use': "이용 약관",
    'Upload credentials': "자격 증명 업로드",
    'The withdrawal is being processed': "출금 진행 중",
    'Cause of failure': "실패 이유",
    'Your shopping cart is still empty': "장바구니가 아직 비어 있습니다.",
    'Log in to view the items in your cart': "장바구니에 담긴 상품을 보려면 로그인하세요.",
    'Browse around': "먹다",
    'Account correlation': "계정 관련",
    'Order management': "주문 관리",
    'Payment method': "결제수단",
    'Collection address': "지불 주소",
    Category: "분류",
    "MyCommission": "내 커미션",
    "Gross income": "총 수익",
    "Direct commission": "직접 커미션",
    "Indirect commission": "간접수수료",
    "Transfer to wallet": "지갑으로 이체",
    "Tip: The transfer amount must be greater than 10USDT": "팁: 이체 금액은 10USDT보다 커야 합니다.",
    "transfer": "옮기다",
    "commission": "수수료",
    "Please enter": "입력해주세요",
    "Team Commission": "팀 커미션 ",

    'Old Password': "이전 비밀번호",
    'Change password': "비밀번호 변경",
    'Gobuy GIFT CARD': "고바이 기프트 카드",
    'High Priced Recycling': "고가 재활용",
    'Data': "날짜",
    'congratulations': "축하해요",
    'Obtain': "얻다",
    'ThankYouForParticipating': "참여해주셔서 감사합니다",

    // navbar"",
    Home: "첫 페이지",
    Search: "찾다",
    ShoppingCart: "장바구니",
    Mine: "내 거",

    // 首页
    // 搜索
    EnterSearchContent: "검색 내용을 입력하세요",
    'Recent searches': "최근 검색어",
    'popular searches': "인기 검색어",
    'Please search': "검색하고 싶은 키워드를 입력해주세요",
    'orderSearch': "검색할 주문 또는 제품명을 입력하세요.",

    // 语言
    'Language selection': "언어 선택",

    // menu
    Brand: "상표",
    Collect: "모으다",
    Manage: "관리하다",
    Order: "주문하다",
    Wallet: "지갑",
    BlindBox: "블라인드 박스",
    MenuGiftCard: "기프트 카드",
    // HotSale
    HotSale: "최신 뉴스가 판매 중입니다...",
    // tabs"",
    TodaysOffer: "플랫폼 추천",
    'Phone': "휴대폰",
    'Smart Watch': "스마트 시계",
    'Smart bracelet': "스마트 팔찌",

    // gobuy
    'home.gobuy.title': "놀라움이 당신을 기다리고 있습니다",
    'home.gobuy.periods': "블라인드 박스 라운드",
    'home.gobuy.freeze': "카운트다운에 참여하세요",
    'home.gobuy.drawing': "카운트다운 시작",
    'home.gobuy.buy': "참가하다",
    'home.gobuy.isbuy': "이미 참여했습니다",
    
    'home.gobuy.jackpot': "상금 풀",
    Purse: "지갑",
    Box: "블라인드 박스",
    'GetAPrize': "상품 받기",
    Discount: "할인",
    when: "언제",
    points: "완전한",
    seconds: "두번째",
    // MessageBox
    'MessageBox.Tips': "힌트",
    'MessageBox.Confirm': "확인하다",
    'MessageBox.Cancel': "취소",
    'MessageBox.buy.box': "정말 이 블라인드 박스를 구매하시겠습니까?",
    // Toast
    'succ': "성공",
    'err': "실수",
    'box.succeeds': "구매 성공",
    'box.frozen': "이미 참여했습니다",
    'box.issue': "블라인드박스는 권당 1개만 구매 가능합니다.",

    // 商品列表
    filter: "필터",
    sales: "판매량",
    selfOP: "자체 운영",
    noMore: "더 이상",
    brand: "상표",
    confirm: "확인하다",
    reset: "다시 놓기",
    ComSor: "종합적인 정렬",
    MostPop: "가장 인기있는",
    HighLow: "가격이 높은 것부터 낮은 것 순으로",
    LowHigh: "가격이 낮은 것부터 높은 것 순으로",
    SalVol: "판매량",
    NewArr: "새로운 도착",

    // 购物车
    'cart.cart': "장바구니",
    'cart.edit': "편집하다",
    'cart.done': "마치다",
    'home.cart.voucher': "쿠폰 받기",
    'home.cart.outstock': "품절",
    'home.cart.offshelf': "선반에서 제거됨",
    'Only': "오직",
    'left': "개인",
    'Promotion': "홍보",
    'cart.all': "모두 선택",
    'cart.total': "총",
    'cart.delete': "삭제",
    'cart.checkout': "빌, 제발",

    // 我的
    'Direct': "직접",
    'Indirect': "간접적인",
    'MyOrders': "내 주문",
    'ViewAll': "모두 보기",
    'Unpaid': "결제 대기 중",
    'ToShip': "배송 대기 중",
    'ToReceive': "영수증 대기 중",
    'ToReview': "평가 대기 중",
    // 盲盒
    'MyBlindBox': "블라인드 박스 목록",
    'WaitingDraw': "추첨을 기다리고 있어요",
    'Opened': "개설(수령/반품)",
    // 礼品卡
    'After sale': "판매 후",
    'GiftCard': "재활용 기록",
    'RecycleGiftCard': "기프트 카드 재활용",
    'Verifying': "확인하다",
    'Rebuying': "재구매",
    'Repurchased': "결제 대기 중",
    'Paid': "결제가 완료되었습니다.",
    // 常用工具
    'CommonTools': "일반적인 도구",
    'MyWallet': "내 지갑",
    'VirtualOrders': "가상 주문",
    'Refunds': "환불하다",
    'MyFriends': "내 친구들",
    'ChatList': "채팅 목록",
    'RealNameVerification': "실명인증",
    'MyFavorites': "내 컬렉션",
    'Addresses': "주소 관리",
    'MyReviews': "내 리뷰",
    'BrowsingHistory': "역사 찾아보기",
    'Promotions': "프로모션",
    'StoreManagement': "매장 관리",
    'BecomeASeller': "판매자가 되세요",

    // 订单列表
    'SearchPlaceholder': "검색할 주문상품명을 입력하세요",
    All: "모두",
    OrderNo: "주문 번호",
    items: "조각들",
    ShippingFee: "화물",
    'Refund in Progress': "환불 진행 중",
    'Cancel Order': "주문 취소",
    'Refund': "환불하다",
    'Track Shipping': "물류 확인",
    'Confirm Receipt': "물품 수령을 확인하다",
    'Evaluate': "평가하다",
    'Delete': "삭제",
    'Pay': "지불",
    'MessageBox.delete.order': "정말로 이 주문을 삭제하시겠습니까?",
    'MessageBox.cancel.order': "정말로 이 주문을 취소하시겠습니까?",
    'MessageBox.receive.order': "이 주문이 접수됐나요?",
    // 订单详情
    'Order Details': "주문 세부정보",
    'Pickup Code': "픽업 코드",
    'Complaint': "불평",
    'After-Sales': "판매 후",
    'Gift': "선물",
    'Order Date': "주문 날짜",
    'Used voucher worth': "바우처 사용 금액",
    'CNY': "인민폐",
    'Payment Method': "결제수단",
    'Total Product Amount': "총 상품금액",
    'Shipping Fee': "화물",
    'Amount Paid': "지불금액",
    'Return': "상품을 반품하다",
    // 盲盒列表
    'Pending Draw': "추첨을 기다리는 중",
    'Pending Unboxing': "개봉예정",
    'Unboxed': "이미 켜져 있음",
    'Collected': "받았다",
    'Recycled': "재활용",
    'Unknown': "알려지지 않은",
    'Claim': "받다",
    'Recycle': "자사주 매입",
    'Unbox': "켜다",
    'MessageBox.recycle.box': "이 블라인드 박스를 재활용하시겠습니까?",
    // 盲盒详情
    'Mystery Box Details': "블라인드 박스 세부정보",
    'Unopened': "켜지지 않음",
    'box.opened': "켜지지 않음",
    'Claimed': "받았다",
    'Confirm Claim': "수집 확인",
    'MessageBox.pick.box': "이 블라인드 박스를 추출하시겠습니까?",
    // 盲盒提货
    'Please add address': "주소를 추가해주세요",
    // 礼品卡列表
    'Face Value Total': "총 액면가",
    // 礼品卡详情
    'Gift Card Details': "기프트 카드 세부정보",
    'Card number': "카드번호",
    'Activation code': "활성화 코드",
    'Actual recovery price': "실제 재활용 가격",
    // 礼品卡回收
    'Gift Card Recycling': "기프트 카드 재활용",
    'Confirm Recycling': "재활용 확인",
    'Please enter the card number': "카드번호를 입력해주세요",
    'Please enter the activation code': "활성화 코드를 입력하세요",
    'MessageBox.recycle.gift': "이 기프트 카드를 재활용하시겠습니까?",

    // 我的钱包
    'My Wallet': "내 지갑",
    'Available Balance': "사용 가능한 잔액",
    'Gift Balance': "기프트 잔액",
    'All': "모두",
    'Next event loading': "다음 이벤트 로드 중",
    'Frozen Funds': "자금 동결",
    'Recharge': "충전하다",
    "can": "가능",
    'Withdraw': "현금 인출",
    'Withdrawal Accounts': "계좌 출금",
    // 充值
    'Recharge Details': "충전 세부정보",
    'Recharge Order No.': "충전 주문 번호",
    'Recharge Amount': "충전금액",
    'Creation Time': "생성 시간",
    'MessageBox.recharge.pop': "충전금액을 입력해주세요",
    // 付款
    'payment': "지불",
    'Order submitted successfully, please select payment method': "주문이 성공적으로 제출되었습니다. 결제 수단을 선택하세요.",
    'Rechargeable card': "충전식 카드",
    'Please enter a hash': "해시를 입력하세요.",
    'Immediate payment': "지금 결제",
    'Wait for the file to load': "파일이 로드될 때까지 기다려 주십시오.",
    // 提现
    'Withdrawal Details': "출금내역",
    'Withdrawal Amount': "출금금액",
    'Application Time': "신청시기",
    'New Application': "새로운 애플리케이션",
    'Payment Password': "결제 비밀번호",
    'New Payment Password': "새로운 결제 비밀번호",
    'Recipient Information': "수취인 정보",
    'Submit': "제출하다",
    'Add Recipient Account First': "먼저 결제 계좌를 추가하세요.",
    'Please bind your mobile phone or email first': "먼저 휴대폰이나 이메일을 묶어주세요",
    // 设置
    'Account Settings': "계정 설정",
    'Change Login Password': "로그인 비밀번호 변경",
    'Change Payment Password': "결제 비밀번호 변경",
    'Log Out': "로그아웃",
    'Mobile': "휴대폰",
    'Verification Code': "인증코드",
    'Email': "우편",
    'New Password': "새 비밀번호",
    'Confirm Password': "비밀번호 확인",
    'Modify': "개정하다",
    'Bind': "제본",
    ' Mobile': "휴대폰",
    ' Email': "우편",
    // 资金详情
    'Fund Details': "자금 세부정보",
    'Withdrawal Account': "계좌 출금",
    'Account Type': "계좌 유형",
    'USDT Address (opBNB)': "USDT-opBNB",
    'Edit': "편집하다",
    'Delete': "삭제",
    'Add New': "새 계정 추가",
    'MessageBox.delete.bank': "이 출금 계좌를 삭제하시겠습니까?",
    // 登录
    'Login': "로그인",
    'Sign Up': "등록하다",
    'Normal Login': "일반 로그인",
    'Username / Email / Phone Number': "사용자 이름/이메일",
    'Enter Phone Number': "휴대폰번호를 입력해주세요",
    'Enter Email': "이메일을 입력해주세요",
    'Enter SMS Code': "SMS 인증번호를 입력해주세요",
    'Enter Password': "비밀번호를 입력해주세요",
    "enter_login_password_for_verification": "로그인 비밀번호를 입력하여 인증해주세요",
    'Forgot Password': "비밀번호를 잊어버려",
    'Third-party Login': "제3자 로그인",
    'Please complete the form': "양식을 작성해주세요",
    'WeChat': "위챗",
    'Weibo': "웨이보",
    'QQ': "QQ",
    'phone login': "모바일 로그인",
    'Login Expired': "로그인이 만료되었습니다",
    'Please enter your phone number first': "먼저 휴대폰 번호를 입력해주세요",
    'Please enter your username/email/phone number': "사용자 이름/이메일을 입력하세요.",
    'Please enter your password': "비밀번호를 입력해주세요",
    'Password must be at least 6 characters': "비밀번호는 6자 이상이어야 합니다.",
    'Please enter an 11-digit phone number': "휴대전화번호 11자리를 입력해주세요.",
    'Please wait for the file to finish loading': "파일이 로드될 때까지 기다려 주십시오.",
    'send': "보내다",
    'signUpTips': "귀하의 개인 데이터는 웹사이트 전체에서 귀하의 경험을 지원하고, 귀하의 계정에 대한 액세스를 관리하며, 당사의 개인정보 보호정책에 설명된 기타 목적을 위해 사용됩니다.",

    // 注册
    'Sign Up': "등록하다",
    'Referrer': "추천인",
    'Invitation code': "초대코드",
    'Please.enter.Invitation.code': '초대 코드를 입력해주세요',
    'Email.verification.code': '이메일 인증 코드',
    'Invite friends': "친구 초대",
    'Username': "사용자 이름",
    'Full Name': "실명",
    'Set Password': "비밀번호 설정",
    'Confirm Password': "비밀번호 확인",
    'Phone Number': "전화 번호",
    'Email': "이메일",
    'Username: 3-25 chars, letters & numbers': "사용자 이름: 3~25자, 문자, 숫자",
    '6-20 digits/letters/symbols': "6~20자리 숫자/문자/기호",
    'By clicking sign up, you agree to': "등록을 클릭하면 동의하는 것으로 간주됩니다.",
    'User Agreement': "사용자 계약",
    'Please check the user agreement': "이용약관을 확인해주세요",
    'Please enter a username with 3-25 characters': "3~25자의 사용자 이름을 입력하세요.",
    'Enter SMS Verification Code': "SMS 인증번호를 입력해주세요",
    'Please enter your phone number': "휴대폰 번호를 입력해주세요",
    'Please enter the verification code': "인증번호를 입력해주세요",
    'Please enter a 6-digit verification code': "인증번호 6자리를 입력해주세요",
    'Please enter a password with 6-20 characters': "6~20자의 비밀번호를 입력하세요.",
    'Please enter the confirm password': "확인 비밀번호를 입력해주세요",
    'The confirm password does not match the entered password': "확인 비밀번호가 입력한 비밀번호와 일치하지 않습니다.",

    // 密码恢复
    'Password Recovery': "비밀번호 복구",
    'Forgot Password': "비밀번호를 잊어버려",
    'Forget.email.tips': "귀하의 계정이 아직 이메일 번호와 연결되지 않은 경우 플랫폼 관리자에게 문의하여 비밀번호를 복구하십시오.",

    // 通知
    'Notification Message': "알림 메시지",
    'Direct Message': "사신",
    'System Message': "시스템 메시지",
    'Leave a Message': "메시지",

    // 配送地址
    'Delivery Address': "배송 주소",
    'The store is no longer valid, please edit the delivery address again': "이 상점은 더 이상 유효하지 않습니다. 배송 주소를 다시 편집하십시오.",
    'Default address': "기본 주소",
    'Add address': "주소 추가",
    'Edit address': "주소 수정",
    'MessageBox.delete.address': "이 주소를 삭제하시겠습니까?",
    'name': "이름",
    'phone': "전화 번호",
    'district': "구역",
    'address': "주소",
    'default address': "기본 주소",
    'save and use': "저장하고 사용하세요",
    'save': "구하다",
    'Please select a region': "지역을 선택해주세요",
    'Please fill in the recipient name': "수취인 이름을 입력해주세요",
    'Name must be 2-15 characters': "이름은 2~15자여야 합니다.",
    'Please fill in the mobile phone number': "휴대폰번호를 입력해주세요",
    'Please select your location': "귀하의 위치를 ​​선택해 주세요",
    'Please fill in the detailed address': "자세한 주소를 입력해주세요",

    // 浏览历史
    'Browsing History': "역사 찾아보기",
    'Clear browsing history': "인터넷 사용 기록 삭제",

    // 推广会员
    'Promotion member': "회원 승격",
    "PromotionPoster": "홍보 포스터",
    "MemberName": "회원 이름",
    "MyAssets": "내 자산",
    "DistributedAmount": "분배금액",
    "NumberOfDistributedProducts": "제품 수량 할당",
    "DistributedProductAmount": "분배금액",
    "MyTeam": "내 팀",
    "LevelOneMembers": "일등회원",
    "LevelTwoMembers": "두 번째 레벨 회원",
    "PromotionPoster": "홍보 포스터",
    "PromotionMembers": "회원 승격",
    "PromotionPerformance": "프로모션 성과",
    "ViewPromotionLink": "프로모션 링크를 보려면 클릭하세요.",
    "PromoteViaWeChatQRCode": "WeChat QR 코드를 통해 홍보",
    "Copy": "복사",
    "BrowserNotSupportedCopyManually": "귀하의 브라우저는 직접 복사를 지원하지 않습니다. 수동으로 복사하십시오.",
    "GiftCardRecoveryTotal": "재활용된 기프트 카드의 총 개수",
    "TodaysGiftCardRecoveryCount": "오늘의 기프트카드 재활용 횟수",
    "RegistrationDate": "등록일",
    "LastLogin": "마지막 로그인",
    "Promotion Commission": "프로모션 커미션",

    // userinfo 个人信息
    "Personal Info": "개인정보",
    "Nickname": "닉네임",
    "Birthdate": "생일",
    "Save": "구하다",
    "CropImage": "사진 자르기",
    "UseImage": "사진 사용",

    // goodsDetail 商品详情
    "Off": "할인",
    "Sold": "판매된",
    "Product": "제품",
    "Comment": "논평",
    "Details": "세부",
    "ReportViolation": "보고서",
    "Cart": "장바구니",
    "ChatMessages": "채팅 메시지",
    "MyShop": "내 가게",
    "MerchantLogin": "판매자 로그인",
    "Share": "공유하다",
    "ShareTo": "공유 대상",
    "WeChat": "위챗",
    "Copy": "복사",
    "Poster": "포스터",
    "BrowserNotSupportedCopyManually": "귀하의 브라우저는 직접 복사를 지원하지 않습니다. 수동으로 복사하십시오.",
    "Follow": "집중하다",
    "Unfollow": "언팔로우",
    "PleaseSelectQuantityAndCategory": "수량과 카테고리를 선택해주세요.",
    "SelectedWithQuantity1": "{사양}, 수량 {번호}개를 선택했습니다.",
    "SelectedQuantity1": "수량 {number}개를 선택했습니다.",
    "SelectedWithQuantity2": "{사양}, 수량 {번호}개를 선택했습니다.",
    "Add to cart": "장바구니에 추가",
    "Buy now": "지금 구매하세요",
    "Stock": "재고 있음",
    "Pieces": "조각들",
    "Quantity": "수량",
    "All": "모두",
    "Good": "좋은 리뷰",
    "Medium": "중립 등급",
    "Bad": "나쁜 리뷰",
    // 评论
    "Product review": "제품 리뷰",
    "anonymous": "익명의",
    "noReviewInfo": "제공된 댓글 정보가 없습니다.",
    "Shop Owners Response": "가게 주인이 대답하다",
    "This product has no current reviews": "현재 이 제품에 대한 리뷰가 없습니다.",
    "Product details": "제품 세부정보",
    "shop": "가게",
    "customerService": "고객 서비스",
    "shoppingCart": "장바구니",
    "addToCart": "장바구니에 추가",
    "buyNow": "지금 구매하세요",
    "outOfStock": "선택하신 상품은 현재 품절입니다. 죄송합니다!",
    "notAvailable": "선택한 제품은 더 이상 구매할 수 없습니다. 죄송합니다!",
    "Store order message": "매장주문 소식",
    "Confirm the order": "주문 확인",
    "productAmount": "상품금액",
    "discount": "할인",
    "shippingFee": "화물",
    "subtotal": "매장 소계",
    "Submit an order": "주문 제출",
    // 退货
    "refundAdd": "환불 추가",
    "back": "반품",
    "refundDescription": "환불 지침:",
    "proofOfRefund": "환불쿠폰",
    "use": "사용",


    // 一元购
    "yi1": "1엔 구매",
    "yi2": "가격 구역",
    "yi3": "구역",
    "yi4": "구매 이력",
    "yi5": "획득한 상품 기록",
    "yi6": "교환 코드 확인",
    "yi7": "출금 신청",
    "yi8": "충전하기",
    "yi9": "참여 수량",
    "yi10": "총 수량",
    "yi11": "부족 수량",
    "yi12": "지금 구매",
    "yi13": "구매 계속하기",
    "yi14": "기타 구역",
    "yi15": "더 불러오기",
    "yi16": "기대해 주세요...",
    "yi17": "구역",
    "yi18": "아니요.",
    "yi19": "반품",
    "yi20": "가격:",
    "yi21": "더 불러오기",
    "yi22": "퀵 페이먼트 - 구매할 상품 정보",
    "yi23": "구매 수량",
    "yi24": "(구매 수량이 많을수록 상품을 획득할 확률이 높아집니다!)",
    "yi25": "합계: ",
    "yi26": "결제 성공",
    "yi27": "결제 실패",
    "yi28": "이유:",
    "yi29": "결과 발표",
    "yi30": "럭키 넘버",
    "yi31": "상품 획득자",
    "yi32": "축하합니다! 이 상품을 획득했습니다",
    "yi33": "발표 시간:",
    "yi34": "구매 시간:",
    "yi35": "상품 획득자의 총 구매 수량: ",
    "yi36": " 구매 코드:",
    "yi37": "수령",
    "yi38": "현금 입금",
    "yi39": "예약 구매",
    "yi40": "구매하기",
    "yi41": "획득 상품 기록",
    "yi42": "당첨일:",

    "hunt1": "교환 코드",
    "hunt2": "운에 축복받다",
    "hunt3": "멈추지 않는 세력",
    "hunt4": "교환 코드",
    "hunt5": "교환 코드:",
    "hunt6": "더 불러오기",
    "hunt7": "교환하고 싶다",
    "hunt8": "교환 코드를 입력해 주세요",
    "hunt9": "교환 가격은 판매 가격의 10% 할인입니다",
    "hunt10": "상품 목록",
    "hunt11": "구역",
    "hunt12": "언어",
    "hunt13": "공지사항",
    "hunt14": "내비게이션",
    "hunt15": "공식 발표",
    "hunt16": "보물 기록",
    "hunt17": "배송 규칙",
    "hunt18": "규칙 설명",
    "hunt19": "교환하고 싶다",
    "hunt20": "문의하기",
    "hunt21": "이메일 주소",
    "hunt22": "추첨 규칙",
    "hunt23": "규칙 개요",
    "hunt24": "1. 번호 할당:",
    "hunt25": "0.1 USDT를 지불할 때마다, 사용자는 럭키 넘버를 1개 획득합니다. 번호는 000001부터 순차적으로 배포되며, 목표 참가자 수 (예: 1000명)에 도달할 때까지 계속됩니다.",
    "hunt26": "2. 추첨 조건:",
    "hunt27": "상품이 목표 참가자 수 (예: 1000명)에 도달하면, 추첨 프로세스에 들어갑니다.",
    "hunt28": "3. 추첨 시간:",
    "hunt29": "마지막 주문이 확인된 후, 블록체인 시간이 '05, 10, 15, 25, 30, 35, 40, 45, 50, 55, 00' 중 하나에 해당하는 가장 가까운 시간을 기다립니다.",
    "hunt30": "4. 당첨 번호 계산:",
    "hunt31": "1. 블록 해시 값에서 순수한 숫자를 추출하고, 참가자 총수로 나눈 나머지를 계산합니다:\n당첨 번호 = (해시 값 내의 순수한 숫자 % 참가자 총수) + 1",
    "hunt32": "2. 계산 결과에 해당하는 번호가 당첨 번호가 됩니다.",
    "hunt33": "참여 단계",
    "hunt34": "사용자는 0.1 USDT를 지불할 때마다 럭키 넘버를 1개 획득합니다.",
    "hunt35": "상품이 목표 참가자 수에 도달하면, 신규 참여는 종료됩니다.",
    "hunt36": "추첨 단계",
    "hunt37": "마지막 주문의 정확한 시간을 기록합니다 (예: 15:47:23).",
    "hunt38": "규칙에 따른 블록체인 시간을 기다립니다:",
    "hunt39": "블록체인 시간이 '05, 10, 15, 25, 30, 35, 40, 45, 50, 55, 00' 중 하나에 해당하는 경우",
    "hunt40": "조건에 맞는 블록 해시 값을 얻습니다.",
    "hunt41": "당첨 단계",
    "hunt42": "블록 해시 값에서 순수한 숫자를 추출합니다.",
    "hunt43": "예시 블록 해시 값: 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123",
    "hunt44": "추출한 순수한 숫자: 16644536521000000342018123",
    "hunt45": "참가자 총수로 나눈 나머지:",
    "hunt46": "당첨 번호",
    "hunt47": "= (추출한 숫자 % 참가자 총수) + 1",
    "hunt48": "추출한 숫자가 16644536521000000342018123이고, 참가자 총수가 1000인 경우:",
    "hunt49": "= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124",
    "hunt50": "결과 발표",
    "hunt51": "플랫폼은 당첨 번호와 해당하는 사용자 정보를 발표합니다.",
    "hunt52": "계산 과정 (주문 시간, 사용한 블록 해시, 추출한 숫자 및 당첨 번호 계산식)을 완전히 공개합니다.",
    "hunt53": "장점",
    "hunt54": "1. 공정성",
    "hunt55": "공개된 블록체인 해시 값을 이용하여, 추첨 결과가 예측 불가능하고 변조 불가능함을 보장합니다.",
    "hunt56": "2. 투명성",
    "hunt57": "사용자는 해시 값과 번호 할당 프로세스를 검증할 수 있습니다.",
    "hunt58": "3. 속도",
    "hunt59": "조건에 맞는 블록이 생성되기를 기다리기만 하면 빠르게 결과를 얻을 수 있습니다.",
    "hunt60": "공지사항 상세",
    "hunt61": "구매 수량:",
    "hunt62": "건",
    "hunt63": "구매 코드 보기",
    "hunt64": "구매 코드:",
    "hunt65": "규칙 설명",
    "hunt66": "주문에 대하여",
    "hunt67": "신속하게 상품을 배송하기 위해, 16:00까지의 주문은 당일 중으로 XX 배송 또는 XX 배송으로 발송합니다. 급한 경우 추가 요금을 지불하여 XX 배송으로 보내는 것도 가능합니다. 다른 배송 서비스는 현재 지원되지 않습니다.",
    "hunt68": "청구서에 대하여",
    "hunt69": "판매된 모든 상품에는 전자 청구서를 발행할 수 있습니다. 주문을 통해 고객 지원에 연락하여 청구서 정보를 제공해주세요. 보통 1~3일 이내에 발행됩니다. 공휴일인 경우 발행이 지연될 수 있습니다.",
    "hunt70": "행운구매",

    "new1": "예시",
    "new2": "이 상품은 총 1000명이 참여해야 합니다. 마지막 주문 시간은 15:47:23입니다.\n추첨 시간에 부합하는 가장 최근 블록 시간은 15:50:00입니다.",
    "new3": "블록 해시 값은:",
    "new4": "해시 값에서 순수한 숫자만 추출:",
    "new5": "당첨 번호 계산:",
    "new6": "당첨 번호",
    "new7": "당첨 번호는 124이며, 해당 번호에 해당하는 사용자가 당첨자입니다.",
    "new8": "교환 완료",
    "new9": "교환 안 함",
    "new10": "안타깝게도, 당첨되지 않았습니다",
    "new11": "축하합니다",
    "new12": "이번 라운드의 상품을 획득했습니다",
    "new13": "교환",
    "new14": "럭키 구매",
    "new15": "상품 수령 완료",


    "new16": "상품을 수령하시겠습니까?",
    "new17": "교환하시겠습니까?",
    "copyS": "복사 성공",
    "copyE": "복사 실패",
    "new18": "상품 전시",
    "new19": "이전 페이지",
    "new20": "다음 페이지",
    "new21": "번째",
    "new22": "페이지",
    "new23": "확인",
    "new24": "추첨 대기 중",

    "tool1": "홈",
    "tool2": "상품",
    "tool3": "공지사항",
    "tool4": "획득 기록",
    "tool5": "배송",
    "tool6": "규칙",
    "tool7": "교환",
    "tool8": "문의",
    "new25": "상품 교환",
    "new26": "gobuy 사용자 이름을 입력하십시오",


    "ship1": "적용 범위",
    "ship2": "이 배송 규칙은 luckybuy 전자상거래 플랫폼에서 이루어지는 모든 주문에 적용됩니다. 플랫폼은 USDT 결제만 허용하며, 신용카드, 현금 결제 또는 운임 공제는 지원하지 않습니다. 이에 따라 다음 규칙이 제정됩니다.",
    "ship3": "1. 미국 내 배송 규칙",
    "ship4": "결제 방법",
    "ship5": "USDT 결제만 가능합니다. 신용카드 및 현금 결제는 지원되지 않습니다.",
    "ship6": "착불 서비스",
    "ship7": "착불 서비스는 미국 내 고객만 이용 가능합니다. 배송비를 미리 지불하실 필요가 없습니다.",
    "ship8": "배송 정책",
    "ship9": "주문 금액에 배송비는 포함되지 않으며, 별도로 지불해야 합니다.",
    "ship10": "배송 범위",
    "ship11": "미국 본토 전 지역으로 배송을 지원합니다.",
    "ship12": "고객 안내",
    "ship13": "주문 후 고객 연락처가 정확한지 확인해야 합니다. 상품 수령 시 고객 또는 위임받은 대표자의 서명이 필요합니다.",
    "ship14": "2. 미국 외 배송 규칙",
    "ship15": "USDT 결제만 가능합니다. 신용카드 및 현금 결제는 지원되지 않습니다.",
    "ship16": "미국 외 지역 고객은 주문 결제 완료 후 별도의 배송비를 추가로 지불해야 합니다.",
    "ship17": "추가 배송비 결제가 완료되면, 플랫폼에서 배송을 진행합니다.",
    "ship18": "착불 정책",
    "ship19": "착불 서비스는 제공되지 않습니다. 미국 외 지역 고객은 주문이 처리되기 전에 배송비를 완납해야 합니다.",
    "ship20": "추가 배송비 결제 절차",
    "ship21": "주문이 완료된 후 플랫폼은 고객 주소를 기준으로 배송비를 산출하고, 추가 금액을 USDT로 결제하도록 안내합니다.",
    "ship22": "배송비 결제가 완료되면, 플랫폼은 배송을 준비하고 물류 추적 정보를 제공합니다.",
    "ship23": "전 세계 모든 국가로 배송을 지원합니다. 구체적인 배송 시간은 현지 물류 상황에 따라 달라집니다.",
    "ship24": "주소 및 연락처 정보가 정확한지 확인해 주세요. 정보 오류로 인한 배송 실패는 고객 책임입니다.",
    "ship25": "플랫폼은 도착지 국가의 관세 정책에 대해 책임지지 않습니다. 고객이 직접 세관 통관 및 추가 수수료를 확인하고 처리해야 합니다.",
    "ship26": "주의사항",
    "ship27": "1. 주문이 결제 완료된 후에는 취소나 환불이 불가능합니다. 결제 전 주문 정보를 신중히 확인해 주세요.",
    "ship28": "2. luckybuy는 운송 중 불가항력(자연재해, 정책 변경 등)으로 인해 발생한 문제에 대해 책임지지 않지만, 고객의 문제 해결을 위해 최선을 다해 지원합니다.",
    "ship29": "3. 기타 문의 사항은 플랫폼 고객센터로 문의해 주세요.",
    "ship30": "이해와 성원에 감사드립니다!",
    "ship31": "luckybuy는 고객님께 최선을 다해 서비스를 제공하겠습니다.",

    // 礼品卡相关
    'Original Price':'원래 가격',
    'Actual Payment':'실제 결제',
    'Balance':'잔액',
    'MessageBox.buy.card': '이 기프트 카드를 구매하시겠습니까?',
    'MyCard':'내 카드',
    'Please upload pictures':'사진을 업로드 해주세요',
    'Share audit list':'감사 목록 공유',
    'Share page':'페이지 공유',
    'Audit result':'감사 결과',
    'Share to the community':'커뮤니티에 공유',
    'imshares1':'단계 소개',
    'imshares2':'1단계: 소셜 미디어에 제품을 공유하세요.',
    'imshares3':'2단계: 제품이 공유된 페이지의 스크린샷을 찍어 GoBuy에 업로드하세요.',
    'Share Time':'공유 시간',
    'Audit status':'감사 상태',
    'Reason for failure':'실패 이유',
    'Pending approval':'승인 대기 중',
    'Approved':'승인됨',
    'Audit failed':'감사 실패',
    'Url Copied': '링크가 성공적으로 복사되었습니다. 공유로 리디렉션됩니다...',
    "Points Logs": "포인트 로그",
    "My Points": "내 포인트",
    "Go Excharge": "교환하러 가기",
    "Confirm points excharge": "모든 포인트를 잔액으로 전환하시겠습니까?",
    'is not share': '당신은 아직 공유 작업을 완료하지 않았습니다',
    'is buied': '당신은 오늘 이미 구매를 완료했습니다',
    'My card': '내 카드',
    "Country/Region": "국가/지역",
    "Contact info": "연락처 정보",
    "Please enter real name": "실명을 입력하세요",
    "Please enter Phone Number": "전화번호를 입력하세요",
    "Please enter State/Province/Region": "주/도/지역을 입력하세요",
    "Please enter City": "도시를 입력하세요",
    "Please enter Street Address": "도로 주소를 입력하세요",
    "Please enter Postal Code": "우편번호를 입력하세요",
    "lucky_draw_winning_products": "추첨 당첨 제품",
    "refundAdd": "환불 요청",
    "refundDescription": "환불 설명",
    "productQualityIssue": "제품 품질 문제",
    "logisticsTransportIssue": "물류 및 운송 문제",
    "sellerPlatformIssue": "판매자 또는 플랫폼 문제",
    "personalReason": "개인적인 이유",
    "otherSpecialCases": "기타 특별한 경우",
    "hunt points rule": "포인트 설명",
    "hunt points rule1": "1. 포인트 적립: 사용자는 행운의 구매에 참여하여 투자한 $0.1마다 1포인트를 적립할 수 있습니다.",
    "hunt points rule2": "2. 포인트 교환: 1포인트 = 0.01%달러",
    'Login Password': "로그인 비밀번호",
    "Level": "등급",
    
    "guide.Rewards": "보상 소개",
    "guide.title": "초보자 가이드",
    "guide.Invitation.Reward": "이벤트 보상",
    "guide.Order.Sharing": "Order Sharing",
    "guide.section1.title": "럭키바이 구매 가이드",
    "guide.section1.step1": "구매 선택: 달러 섹션에 들어가서 원하는 상품을 고르세요.",
    "guide.section1.step2": "수량 선택: 참여할 구매 수량을 입력하세요.",
    "guide.section1.step3": "구매 수량: 1개 구매 시 단 $0.1만 결제하면 됩니다.",
    "guide.section1.step4": "추첨 대기: 시스템이 자동으로 행운의 당첨자를 선정합니다.",
    "guide.section2.title": "블라인드 박스 구매 가이드",
    "guide.section2.step1": "블라인드 박스 열기: 블라인드 박스 섹션을 클릭하세요.",
    "guide.section2.step2": "즉시 참여: 1달러를 지불하세요.",
    "guide.section2.step3": "상품 공개: 최대 300만 달러 상당의 상품을 획득하세요.",
    "guide.section3.title": "기프트 카드 구매 가이드",
    "guide.section3.step1": "커뮤니티 공유: 즉시 이벤트를 공유하고 정보를 업로드하세요.",
    "guide.section3.step2": "금액 선택: 자유롭게 기프트 카드 가격을 선택하세요.",
    "guide.section3.step3": "100개의 기프트 카드를 단 $98에 구매하세요.",
    "guide.section3.step4": "즉시 재구매: 100% 재구매로 $2 수익",
    "guide.tip.title": "따뜻한 팁: 놓치지 말아야 할 최고의 혜택",
    "guide.tip.luckyBuy": "단 0.1달러로 참여 가능하며, 1달러부터 50,000달러까지의 상품을 획득할 기회!",
    "guide.tip.luckyBuy1": "팀 커미션 보상: 친구를 초대하여 구매하면 최대 0.2% 커미션을 받을 수 있습니다!",
    "guide.tip.luckyBuy2": "포인트 교환: 럭키바이 1회 구매당 1포인트 적립, 1000포인트 = 0.1달러!",
    "guide.tip.example": "예시:",
    "guide.tip.example1": "사용자 A를 초대하고, A가 1000달러 구매 → 당신은 2달러 커미션을 획득합니다.",
    "guide.tip.example11": "A가 사용자 B를 초대하고, B가 1000달러 구매 → 당신은 추가로 1달러 커미션을 획득합니다.",
    "guide.tip.boxTitle": "블라인드 박스 추첨",
    "guide.tip.box": "1달러에 1회 참여, 상품 가치는 최대 300만 달러!",
    "guide.tip.cardTitle": "기프트 카드",
    "guide.tip.card": "팀 커미션: 친구를 초대하여 구매하면 최대 0.4% 커미션을 받을 수 있습니다!",
    "guide.tip.example2": "사용자 A가 $100 상당의 기프트 카드를 구매하도록 초대하면 $0.4의 커미션을 받을 수 있습니다.",
    "guide.tip.example3": "A가 사용자 B를 초대하고 B가 $100 기프트 카드를 구매하면 추가로 $0.2 커미션을 받게 됩니다.",
    "guide.tip.callToAction": "지금 바로 참여하여 당신의 행운 여정을 시작하세요!",
    "guide.warning.title": "Warm Reminder",
    "guide.warning.rule1": "What situations cause commission invalidation?",
    "guide.warning.answer1": "Using software or other platforms to maliciously obtain commissions will result in all commissions being deducted and account suspension once verified.",
    "guide.warning.rule2": "Can I earn commission by inviting myself?",
    "guide.warning.answer2": "No. We conduct manual checks, and any verified cheating will result in all commissions being deducted, invitation qualifications revoked, and account clearance.",
    "invite.title": "혜택이 도착했습니다 | 친구를 초대하고 4개의 큰 상을 얻으세요!",
    "invite.reward1.title": "보상 1: 그룹에 초대하고 쉽게 달러+기프트 카드를 획득",
    "invite.reward1.item1": "신규 멤버 10명을 그룹에 초대할 때마다 레드 패킷 보상을 즉시 받으세요!",
    "invite.reward1.item2": "동시에 1달러 기프트 카드를 드립니다",
    "invite.reward1.item3": "더 많이 초대할수록 더 많은 보상을 받습니다! 레드 패킷은 즉시 지급, 기프트 카드는 즉시 교환 가능!",
    "invite.reward2.title": "보상 2: 럭키바이, 누워서도 커미션을 벌자",
    "invite.reward2.item1": "친구가 럭키바이에 참여할 때마다 커미션을 받을 수 있습니다!",
    "invite.reward2.item2": "커미션 무한 상한, 많이 살수록 많이 벌어요!",
    "invite.reward3.title": "보상 3: 기프트 카드",
    "invite.reward3.item1": "친구가 기프트 카드를 구매하면 즉시 커미션이 지급됩니다!",
    "invite.reward3.item2": "제로 비용 공유 링크, 자동 추적, 아주 간단한 조작:",
    "invite.reward3.item3": "링크 전송 → 친구 주문 → 돈 기다리기!",
    "invite.callToAction": "지금 바로 친구를 그룹에 초대하고 모든 혜택을 챙기세요! 함께 놀면서 돈 벌자!",
    "share.title": "GoBuy 당첨 경험 공유하고 1달러 기프트 카드 받기",
    "share.subtitle": "공유 제목",
    "share.content1": "GoBuy 럭키 쇼핑에 감사드립니다! 저희 회원 중 한 명이 소액 투자로 상품을 당첨하고 성공적으로 출금했습니다!✨",
    "share.content2": "이제 당신 차례입니다! 당첨 경험을 공유하기만 하면 무료 1달러 GoBuy 기프트 카드를 받으실 수 있습니다! 놓치지 마세요—간단하고 보상이 풍부하며 재미있습니다!",
    "share.inviteLink": "당신의 초대 코드 첨부:",
    "share.stepsTitle": "참여 방법:",
    "share.step1": "럭키바이 구역에서 구매/주문 코드의 스크린샷 업로드",
    "share.step2": "‘축하합니다! 당첨되었습니다!’ 메시지 스크린샷 업로드",
    "share.step3": "출금 신청 및 거래 성공 스크린샷 업로드",
    "share.step4": "위 단계를 완료한 후 SNS에서 공유한 스크린샷을 고객 지원팀에 보내 확인받으세요",
    "share.email": "고객 지원 이메일:",
    "share.footer": "행운이 함께하길—계속 플레이하고 계속 이기세요! GoBuy—매일 쇼핑을 즐겁고 보람 있게!",
    "doubleBet.title": "배팅 기적｜3단계로 역전하고 큰 상을 획득하세요!",
    "doubleBet.step1": "1라운드: 1달러 구역을 선택하고, 0.5달러를 구입하고, 5개 단위를 구입한 후 당첨되면 즉시 멈춥니다.",
    "doubleBet.step2": "당첨되지 않으면, 2라운드: 3달러 구역을 선택하고, 1.5달러를 구입하고, 15개 단위를 구입한 후 당첨되면 즉시 멈춥니다.",
    "doubleBet.step3": "여전히 당첨되지 않으면, 3라운드: 8달러 구역을 선택하고, 4달러를 구입하고, 40개 단위를 구입하여 당첨을 축하합니다.",
    "doubleBet.step4": "당첨 후, 이전 두 라운드의 손실을 커버하고 이익을 얻으며, 다시 1라운드로 돌아갑니다.",
    "invite.reward4.title": "보상 4: 한정 혜택 | 신규 사용자 전용 선물",
    "invite.reward4.step1": "1회의 행운 구매에 무료로 참여",
    "invite.reward4.step2": "1회의 미스터리 박스 로또를 무료로 활성화",
    "invite.reward4.step3": "지정된 작업을 완료하고 추가 $1 현금을 받으세요",
    "reward.register.title": "가입 보상",
    "reward.register.point1": "신규 회원은 가입 시 한 번의 무료 럭키바이 참여 기회를 받습니다.",
    "reward.register.point2": "가입 후 그룹에 참여하면 홍바오 이벤트에 참가할 수 있습니다.",
    "reward.task.title": "미션 보상",
    "reward.task.point1": "게스트로 로그인하여 블라인드 박스를 1회 열어보세요.",
    "reward.task.point2": "아래 3개의 럭키바이 체험을 각 존별 1회 수행하세요:",
    "reward.task.subtask1": "$1 존: $0.5 구매",
    "reward.task.subtask2": "$3 존: $1.5 구매",
    "reward.task.subtask3": "$8 존: $4 구매",
    "reward.task.point3": "위 2가지 미션을 완료하면 $1 활동 보상 지급!",
    "reward.share.title": "공유 보상",
    "reward.share.desc": "GoBuy에서 서프라이즈 블라인드 박스와 행운 추첨에 당첨되었어요!",
    "reward.share.desc3": "가입하자마자 당첨됐어요 — 대박이에요!",
    "reward.share.desc4": "✨당첨된 스크린샷을 공유하면 $1 보상을 드려요.",
    "reward.share.desc1": "친구 10명을 초대하고 가입을 완료하면 $1을 받을 수 있습니다. 1,000명을 초대하면 $100 보상! 제한 없이, 많이 초대할수록 더 많은 보상!",
    "reward.invite.title": "초대 보상",
    "reward.invite.desc": "친구 10명을 성공적으로 초대하고 회원가입을 완료하세요.",
    "reward.share.desc2": "위의 작업을 완료하면 공유 및 초대 보상을 받을 수 있습니다!",
    "reward.invite.desc1": "위의 작업을 완료하면 초대 이벤트 보상을 받을 수 있습니다!",
    "account.bank": "은행",
    "account.name": "계좌 이름",
    "bank.name": "은행 이름",
    "account.number": "계좌 번호",
    "account.ifsc": "IFSC 코드",
    "account.type": "계좌 유형",
    "bank.upi.code": "UPI 코드",
    "bank.upi": "UPI 스캔",
    "save.img.save": "위 이미지를 길게 눌러 저장하세요",
    "bank.pay.tip": "팁: 이체 시 정확한 INR 금액을 입력하지 않으면 시스템이 자동으로 입금을 인식하지 못합니다.",
    "bank.upi.order": "UPI 거래 ID / 참조 번호",
    "Please enter a upi order": "UPI 거래 ID / 참조 번호를 입력하세요",



    "guide.title": "User Guide",
    "guide.section1.title": "Lucky Buy",
    "guide.section1.step1": "Each $0.1 = 1 entry",
    "guide.section1.step2": "System randomly draws → Win $1–$50,000",

    "guide.section2.title": "Blind Box",
    "guide.section2.step1": "Each $1 = 1 entry this round",
    "guide.section2.step2": "Win up to $3,000,000 jackpot",

    "guide.section3.title": "Gift Card",
    "guide.section3.step1": "$98 = $100 Gift Card",
    "guide.section3.step2": "System buyback → Earn $2 profit",

    "guide.tip.callToAction": "Join Now",

    "guide.Invitation.Reward": "Invitation Rewards",
    "reward.register.title": "Registration Reward",
    "reward.register.point1": "New users register → 🎟️ Get 1 Lucky Buy chance",
    "reward.register.point2": "✨ Automatically granted, no need to apply",

    "reward.recharge.title": "First Recharge Reward",
    "reward.recharge.point1": "New users' first recharge → 🎁 Get $2 reward",
    "reward.recharge.point2": "📩 Customer service email: gobuyusa888@gmail.com",
    "reward.task.point3": "Complete tasks to unlock more rewards",

    "reward.invite.title": "Invite Friends Reward",
    "reward.invite.point1": "Invite friends to recharge → 🎁 Get $1 reward",
    "reward.invite.point2": "No limit, the more invites, the more rewards!",
    "reward.invite.point3": "Automatically granted, no need to apply",

    "share.rewardTitle": "Sharing Reward",
    "share.rewardStep1": "Share your Lucky Buy / Blind Box / Gift Card winning screenshot to the community",
    "share.rewardStep2": "Share once = Reward $1",
    "share.rewardStep3": "Each user can claim only once",
    "share.email": "Please send email to gobuyusavip@gmail.com",

    "share.guestTitle": "Guest Task Reward",
    "share.guestStep1": "Complete the following 2 tasks:",
    "share.guestStep2": "1️⃣ Purchase 1 Lucky Buy",
    "share.guestStep3": "2️⃣ Purchase 3 Blind Boxes",
    "share.guestStep4": "⚠️ Each user can claim only once",
    "share.guestContact": "Customer Service Email: gobuyusa888@gmail.com",

    "share.teamTitle": "Team Reward",
    "share.teamStep1": "🔗 Users registered through your invitation link = your team members",
    "share.teamStep2": "🏆 Reward rules:",
    "share.teamStep3": "• Invite 10 active members → Reward $1",
    "share.teamStep4": "• Invite 1000 active members → Reward $100",
    "share.teamNote": "⚠️ Active members = users who recharge and complete at least one purchase (Gift Card / Blind Box / Lucky Buy).",
    "share.teamContact": "Customer Service Email: gobuyusa888@gmail.com",

    "guest.rewardTitle": "Guest Task Reward",
    "guest.intro": "Complete the following 2 tasks:",
    "guest.task1": "Purchase 1 Blind Box",
    "guest.task2": "Purchase 3 Lucky Draws",
    "guest.limit": "Each user can claim once only",

    "team.rewardTitle": "Team Reward",
    "team.ruleIntro": "Users registered through your invitation link = your team members",
    "team.ruleTitle": "Reward Rules:",
    "team.rule1": "Invite 10 active members → Reward $1",
    "team.rule2": "Invite 1000 active members → Reward $100",
    "team.note": "Active member = A user who registers, recharges, and makes at least one purchase (Gift Card / Mystery Box / Lucky Draw).",

    
    "reward.firstCharge.title": "First Deposit Reward",
    "reward.firstCharge.point1": "New users first deposit → 🎁 get $2 bonus",
}
export default Korean
